/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable @typescript-eslint/no-unused-vars, no-restricted-syntax */

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as Types from '../../../types/definitions/vendor/graphql-schema.d';

const defaultOptions = {} as const;

export type ShoppingBagAddItemMutationVariables = Types.Exact<{
  input: Types.ShoppingBagAddItemInput;
}>;

export type ShoppingBagAddItemMutation = {
  __typename?: 'Mutation';
  shoppingBagAddItem?: {
    __typename?: 'ShoppingBagAddItemPayload';
    result:
      | {
          __typename: 'ShoppingBagAddItemError';
          code: Types.ShoppingBagAddItemErrorCode;
        }
      | {
          __typename: 'ShoppingBagAddItemSuccess';
          shoppingBag: {
            __typename?: 'ShoppingBag';
            id: string;
            subtotal: {
              __typename?: 'Money';
              value: number;
              currency: Types.Currency;
            };
            outOfStocks: {
              __typename?: 'ShoppingBagItem';
              id: string;
              source?: string | null;
              collection?: string | null;
              quantity: number;
              limitedStock: boolean;
              metadata?: {
                __typename?: 'ShoppingBagItemMetadata';
                outfit?: { __typename?: 'Outfit'; id: string } | null;
                keptSku?: { __typename?: 'Sku'; id: string } | null;
              } | null;
            }[];
            items: {
              __typename?: 'ShoppingBagItem';
              id: string;
              source?: string | null;
              collection?: string | null;
              quantity: number;
              limitedStock: boolean;
              metadata?: {
                __typename?: 'ShoppingBagItemMetadata';
                outfit?: { __typename?: 'Outfit'; id: string } | null;
                keptSku?: { __typename?: 'Sku'; id: string } | null;
              } | null;
            }[];
          };
        };
  } | null;
};

export type BagItemFragment = {
  __typename?: 'ShoppingBagItem';
  id: string;
  source?: string | null;
  collection?: string | null;
  quantity: number;
  limitedStock: boolean;
  metadata?: {
    __typename?: 'ShoppingBagItemMetadata';
    outfit?: { __typename?: 'Outfit'; id: string } | null;
    keptSku?: { __typename?: 'Sku'; id: string } | null;
  } | null;
};

export const BagItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BagItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShoppingBagItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'collection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitedStock' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadata' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outfit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'keptSku' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ShoppingBagAddItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shoppingBagAddItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ShoppingBagAddItemInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shoppingBagAddItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ShoppingBagAddItemSuccess',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shoppingBag' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subtotal' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'outOfStocks',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'BagItem',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'BagItem',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ShoppingBagAddItemError',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...BagItemFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;
export type ShoppingBagAddItemMutationFn = Apollo.MutationFunction<
  ShoppingBagAddItemMutation,
  ShoppingBagAddItemMutationVariables
>;

/**
 * __useShoppingBagAddItemMutation__
 *
 * To run a mutation, you first call `useShoppingBagAddItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShoppingBagAddItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shoppingBagAddItemMutation, { data, loading, error }] = useShoppingBagAddItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShoppingBagAddItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShoppingBagAddItemMutation,
    ShoppingBagAddItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<
    ShoppingBagAddItemMutation,
    ShoppingBagAddItemMutationVariables
  >(ShoppingBagAddItemDocument, options);
}
export type ShoppingBagAddItemMutationHookResult = ReturnType<
  typeof useShoppingBagAddItemMutation
>;
export type ShoppingBagAddItemMutationResult =
  Apollo.MutationResult<ShoppingBagAddItemMutation>;
export type ShoppingBagAddItemMutationOptions = Apollo.BaseMutationOptions<
  ShoppingBagAddItemMutation,
  ShoppingBagAddItemMutationVariables
>;
